import * as $ from 'jquery';
import Papa from 'papaparse';
// upload file
const fileInput = document.querySelector("#txtCSVFile");
const importButton = document.querySelector("#btnImportCSV");
if (fileInput && importButton) {
    // form
    const form = fileInput.closest("form");
    // import button click
    importButton.addEventListener("click", (e) => {
        const data = [];
        const errors = [];
        // clear error message
        clearErrorMessage();
        // check file empty or not
        if ($(form).valid() && fileInput.files.length > 0) {
            const file = fileInput.files[0];
            // parse
            Papa.parse(file, {
                error: (error, file) => {
                    // display error message
                },
                complete: (results, parser) => {
                    // validate data
                    const errors = validateData(results.data);
                    // get all error link
                    const lines = Object.keys(errors);
                    // Allow submit if there is no errors
                    if (lines.length <= 0) {
                        // submit
                        form.submit();
                        console.log('submit');
                    }
                    else {
                        // display errors
                        displayErrors(errors);
                    }
                }
            });
        }
        else {
            // allow submit to trigger empty field validation
            return true;
        }
        // ignore form submit
        e.preventDefault();
        return false;
    });
    // on file change
    fileInput.addEventListener("change", (e) => {
        // clear error message
        clearErrorMessage();
    });
}
function clearErrorMessage() {
    // get error panel
    const errorPanel = document.querySelector("#csvImportErrors");
    errorPanel.style.display = "none";
    errorPanel.querySelectorAll("[data-error-item]:not(.form-error-template)").forEach(element => { element.remove(); });
}
function displayErrors(errors) {
    // get error panel
    const errorPanel = document.querySelector("#csvImportErrors");
    errorPanel.style.display = "block";
    // get html template
    const errorTemplate = document.querySelector(".form-error-template");
    // loop all errors
    for (const line in errors) {
        if (errors.hasOwnProperty(line)) {
            const errorText = `Line ${line} - ${errors[line].join(';')}`;
            // add markup
            const newErrorItem = errorTemplate.cloneNode(true);
            newErrorItem.classList.remove("form-error-template");
            newErrorItem.querySelector("[data-error-details]").textContent = errorText;
            errorPanel.append(newErrorItem);
        }
    }
}
function validateData(data) {
    // ignore header
    data.shift();
    // errors
    const errors = {};
    data.forEach((row, index) => {
        // only check row with value and ignore empty row
        if (row.filter(text => text.length > 0).length > 0) {
            // line number
            const lineNo = index + 2; // ignore header
            // error details
            const errorDetails = [];
            // basic data checking
            const validName = checkName(row[0]);
            const validEmail = checkEmail(row[1]);
            const validNumber = checkNumber(row[2]);
            if (validName !== true) {
                errorDetails.push(validName);
            }
            //if (validEmail !== true) {
            //    errorDetails.push(validEmail);
            //}
            //if (validNumber !== true) {
            //    errorDetails.push(validNumber);
            //}
            // store error
            if (errorDetails.length > 0) {
                errors[lineNo] = errorDetails;
            }
        }
    });
    return errors;
}
function checkEmail(value) {
    if (value && value.trim().length > 0) {
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value)) {
            return true;
        }
    }
    return "invalid email address";
}
function checkNumber(value) {
    if (value && value.trim().length > 0) {
        return true;
    }
    return "invalid number";
}
function checkName(value) {
    if (value && value.trim().length > 0) {
        return true;
    }
    return "no name has been provided";
}
export default undefined;
